import React from 'react';
import { Link } from 'react-router-dom';

type Props = {};

const Footer: React.FC<Props> = () => {
  return (
    <footer className="footer">
      <div className="footerWrap">
        <ul className="footerMenu">
          <li>
            <Link to="/privacy-policy" className="xxs-txt">
              Privacy Policy
            </Link>
          </li>
          <li>
            <Link to="/terms-of-use" className="xxs-txt">
              TERMS OF USE
            </Link>
          </li>
          <li>
            <a href="mailto:contact@metamagnet.org" className="xxs-txt">
              Contact Us
            </a>
          </li>
        </ul>
        <div className="companyInfo">
          <p className="companyName">MetaMagnet Limited</p>
          <p className="companyAddress xs-txt">
            3rd Floor, Palm Grove House, Road Town, Tortola, VG1110, British
            Virgin Islands.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
